import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { socket } from 'api';
import { user } from 'services/user';
import services from 'services';
import { BlueButton, RedButton } from 'libs/ui';
import { setUnrecognized } from 'store/actions/events';
import { CallButtons } from '../call-buttons/call-buttons';
import { Items } from './items';
import { Content, Title, Buttons, Inner, PlateInfo, VehicleClassInfo, ItemContainer } from './unrecognized.styled';
import { Plate } from './plate';
import { VehicleClass } from './vehicle-class';

import { Item } from './item';

export const Unrecognized = (props) => {
  const { t } = useTranslation();
  const { data, id } = props;
  const event = data;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const plateMean = event.data?.vehicle_plate_mean;

  const method = event.data?.method === 'vehicle_class_not_match_mean' ? 'vehicle_class_not_match_mean' : 'plateMean';

  const afterSetPlate = () => {
    // props.getData();
    setLoading(false);
  };

  useEffect(() => {
    socket.on('set_vehicle_plate', afterSetPlate);
    socket.on('rack.set_vehicle_class', afterSetPlate);

    return () => {
      socket.off('set_vehicle_plate', afterSetPlate);
      socket.off('rack.set_vehicle_class', afterSetPlate);
    };
  }, []);

  if (!id) {
    return null;
  }

  /**
   * allow ride
   */
  const ok = () => {
    const msg = { target: id, user_id: user.getId() };
    socket.call('allow_payment_mean', msg);
    cancel();
  };

  /**
   * cancel ride
   */
  const cancel = () => {
    socket.call('confirm_event_by_id', { id: event.id });
    dispatch(setUnrecognized(null));
  };

  /**
   * change plate
   * @param {*} value
   */
  const changePlate = (value) => {
    setLoading(true);
    socket.call('set_vehicle_plate', { target: event.source, vehicle_plate: value });
  };

  const changeVehicleClassMean = (value) => {
    setLoading(true);
    socket.call('racks.set_vehicle_class', { target: event.source, vehicle_class: value });

    setLoading(false);
  };

  const changeVehicleClass = (value) => {
    setLoading(true);
    socket.call('racks.set_vehicle_class', { target: event.source, vehicle_class: value });

    setLoading(false);
  };

  const msg = event.message ?? t('messages.номер распознан некорректно');
  const date = services.formatDateTime(event.created_at);

  return (
    <Content>
      <CallButtons rackId={id} style={{ position: 'absolute', top: '5px', right: '0px' }} small />
      <Title>
        <span style={{ margin: 0 }}>{date}</span> &nbsp; / &nbsp; <span>{event.source_name}:</span> {msg}
      </Title>
      <Inner>
        {method === 'plateMean' && (
          <>
            <Items event={event} rackId={id} />
            {plateMean && (
              <PlateInfo>
                <Plate disabled title={t('means.ГРЗ в СО')} loading={loading} value={plateMean} change={changePlate} />
              </PlateInfo>
            )}
          </>
        )}

        {method === 'vehicle_class_not_match_mean' && (
          <>
            <ItemContainer>
              <Item id={id} item={event.data} refreshPhotoButton={true} refreshPlateButton={true} source={event.source} />
            </ItemContainer>
            <VehicleClassInfo>
              <VehicleClass
                disabled={true}
                title={t('windows.Класс ТС в СО')}
                loading={loading}
                value={event.data?.vehicle_class_mean}
                change={changeVehicleClassMean}
              />

              <VehicleClass
                disabled={false}
                title={t('windows.Класс ТС')}
                loading={loading}
                value={event.data?.vehicle_class}
                change={changeVehicleClass}
              />
            </VehicleClassInfo>
          </>
        )}
        <Buttons>
          <RedButton className="big" onClick={cancel}>
            {t('buttons.Запретить')}
          </RedButton>
          <BlueButton className="big" onClick={ok}>
            {t('buttons.Разрешить')}
          </BlueButton>
        </Buttons>
      </Inner>
    </Content>
  );
};
